export const ALL_NETWORKS_LOGO = require("./logos/png/all-networks-icon.png");
export const ETHEREUM_LOGO = require("./logos/png/ethereum-logo.png");
export const OPTIMISM_LOGO = require("./logos/png/optimism-logo.png");
export const ARBITRUM_LOGO = require("./logos/png/arbitrum-logo.png");
export const BASE_LOGO = require("./logos/png/base-logo.png");
export const BNB_LOGO = require("./logos/png/bnb-logo.png");
export const MONAD_LOGO = require("./logos/png/monad-logo.png");
export const POLYGON_LOGO = require("./logos/png/polygon-logo.png");
export const BLAST_LOGO = require("./logos/png/blast-logo.png");
export const AVALANCHE_LOGO = require("./logos/png/avalanche-logo.png");
export const CELO_LOGO = require("./logos/png/celo-logo.png");
export const WORLD_CHAIN_LOGO = require("./logos/png/world-chain-logo.png");
export const ZORA_LOGO = require("./logos/png/zora-logo.png");
export const ZKSYNC_LOGO = require("./logos/png/zksync-logo.png");
export const SONEIUM_LOGO = require("./logos/png/soneium-logo.png");
export const UNICHAIN_LOGO = require("./logos/png/unichain-logo.png");
export const UNICHAIN_SEPOLIA_LOGO = require("./logos/png/unichain-sepolia-logo.png");
export const UNISWAP_LOGO = require("./logos/png/uniswap-logo.png");
export const UNISWAP_LOGO_LARGE = require("./logos/png/uniswap-logo-large.png");
export const UNISWAP_MONO_LOGO_LARGE = require("./logos/png/uniswap-mono-logo-large.png");
export const UNISWAP_APP_ICON = require("./logos/png/uniswap-app-icon.png");
export const ONBOARDING_QR_ETCHING_VIDEO_LIGHT = require("./videos/light-etching.mp4");
export const ONBOARDING_QR_ETCHING_VIDEO_DARK = require("./videos/dark-etching.mp4");
export const AVATARS_LIGHT = require("./misc/avatars-light.png");
export const AVATARS_DARK = require("./misc/avatars-dark.png");
export const APP_SCREENSHOT_LIGHT = require("./misc/app-screenshot-light.png");
export const APP_SCREENSHOT_DARK = require("./misc/app-screenshot-dark.png");
export const CHROME_LOGO = require("./logos/png/chrome-logo.png");
export const DOT_GRID = require("./misc/dot-grid.png");
export const UNITAGS_BANNER_VERTICAL_LIGHT = require("./graphics/unitags-banner-v-light.png");
export const UNITAGS_BANNER_VERTICAL_DARK = require("./graphics/unitags-banner-v-dark.png");
export const UNITAGS_INTRO_BANNER_LIGHT = require("./graphics/unitags-intro-banner-light.png");
export const UNITAGS_INTRO_BANNER_DARK = require("./graphics/unitags-intro-banner-dark.png");
export const BRIDGING_BANNER = require("./graphics/bridging-banner.png");
export const DAI_LOGO = require("./logos/png/dai-logo.png");
export const USDC_LOGO = require("./logos/png/usdc-logo.png");
export const ETH_LOGO = require("./logos/png/eth-logo.png");
export const OPENSEA_LOGO = require("./logos/png/opensea-logo.png");
export const ENS_LOGO = require("./logos/png/ens-logo.png");
export const FROGGY = require("./graphics/froggy.png");
export const CEX_TRANSFER_MODAL_BG_LIGHT = require("./graphics/cex-transfer-modal-bg-light.png");
export const CEX_TRANSFER_MODAL_BG_DARK = require("./graphics/cex-transfer-modal-bg-dark.png");
export const UNITAG_DARK = require("./graphics/unitag-dark.png");
export const UNITAG_LIGHT = require("./graphics/unitag-light.png");
export const UNITAG_DARK_SMALL = require("./graphics/unitag-dark-small.png");
export const UNITAG_LIGHT_SMALL = require("./graphics/unitag-light-small.png");
export const PUSH_NOTIFICATIONS_CARD_BANNER = require("./graphics/push-notifications-card-banner.png");
export const ONBOARDING_NOTIFICATIONS_DARK = {
  ios: require(`./backgrounds/ios/notifications-dark.png`),
  android: require(`./backgrounds/android/notifications-dark.png`)
};
export const ONBOARDING_NOTIFICATIONS_LIGHT = {
  ios: require(`./backgrounds/ios/notifications-light.png`),
  android: require(`./backgrounds/android/notifications-light.png`)
};
export const FOR_CONNECTING_BACKGROUND_DARK = require("./backgrounds/for-connecting-dark.png");
export const FOR_CONNECTING_BACKGROUND_LIGHT = require("./backgrounds/for-connecting-light.png");
export const CRYPTO_PURCHASE_BACKGROUND_LIGHT = require("./backgrounds/coins-background-light.png");
export const CRYPTO_PURCHASE_BACKGROUND_DARK = require("./backgrounds/coins-background-dark.png");
export const SECURITY_SCREEN_BACKGROUND_DARK = {
  ios: require(`./backgrounds/ios/security-background-dark.png`),
  android: require(`./backgrounds/android/security-background-dark.png`)
};
export const SECURITY_SCREEN_BACKGROUND_LIGHT = {
  ios: require(`./backgrounds/ios/security-background-light.png`),
  android: require(`./backgrounds/android/security-background-light.png`)
};
export const DEAD_LUNI = require("./graphics/dead-luni.png");
export const UNITAGS_ADRIAN_LIGHT = require("./graphics/unitags/adrian-light.png");
export const UNITAGS_ADRIAN_DARK = require("./graphics/unitags/adrian-dark.png");
export const UNITAGS_ANDREW_LIGHT = require("./graphics/unitags/andrew-light.png");
export const UNITAGS_ANDREW_DARK = require("./graphics/unitags/andrew-dark.png");
export const UNITAGS_BRYAN_LIGHT = require("./graphics/unitags/bryan-light.png");
export const UNITAGS_BRYAN_DARK = require("./graphics/unitags/bryan-dark.png");
export const UNITAGS_CALLIL_LIGHT = require("./graphics/unitags/callil-light.png");
export const UNITAGS_CALLIL_DARK = require("./graphics/unitags/callil-dark.png");
export const UNITAGS_FRED_LIGHT = require("./graphics/unitags/fred-light.png");
export const UNITAGS_FRED_DARK = require("./graphics/unitags/fred-dark.png");
export const UNITAGS_MAGGIE_LIGHT = require("./graphics/unitags/maggie-light.png");
export const UNITAGS_MAGGIE_DARK = require("./graphics/unitags/maggie-dark.png");
export const UNITAGS_PHIL_LIGHT = require("./graphics/unitags/phil-light.png");
export const UNITAGS_PHIL_DARK = require("./graphics/unitags/phil-dark.png");
export const UNITAGS_SPENCER_LIGHT = require("./graphics/unitags/spencer-light.png");
export const UNITAGS_SPENCER_DARK = require("./graphics/unitags/spencer-dark.png");
